import { Grid, PropertyFilterProps } from '@amzn/awsui-components-core';
import React, { useState } from 'react';
import { BarRaiserDashboardOverview } from './BarRaiserDashboardOverview';
import { BarRaiserLeaderboard } from './BarRaiserLeaderboard';
import { WorkflowTableContext } from '../../contexts/WorkflowTableContext';
import ContentWorkflowTableV3 from '../workflow-viewer/ContentWorkflowTableV3';
import { WorkflowTableIdentity } from '../../common/CookieRegistry';
import { BarRaiserDashboardInfo } from '@amzn/awscat-pattern-library-service-model';
import { useBarRaisers } from '../content/table/Hooks';
import { getDashboardOverview } from '../utils/BarRaiser';
import {
  QueryGroup,
  ServerSideQueryContentsProvider,
} from '../content/table/ServerSideQueryContentsProvider';
import { VisibleContentOption } from '../workflow-viewer/ContentWorkflowTableDefinitions';
import constants from '../../common/constants';

export interface BarRaiserDashboardTabProps {
  headerSuffix: string;
  queryGroups: QueryGroup[];
  queryGroupsOperation: PropertyFilterProps.JoinOperation;
  techDomain: string;
  allContentTableColumns: any[];
  contentSelectorOptions: VisibleContentOption[];
}

export const DraftBarRaiserDashboard = (props: BarRaiserDashboardTabProps) => {
  const {
    techDomain,
    headerSuffix,
    queryGroups,
    queryGroupsOperation,
    allContentTableColumns,
    contentSelectorOptions,
  } = props;
  const header = `${constants.BAR_RAISER_DASHBOARD_HEADER} - ${headerSuffix}`;

  const tableDataProvider = (
    <ServerSideQueryContentsProvider
      queryGroups={queryGroups}
      queryGroupOperation={queryGroupsOperation}
      tableId={WorkflowTableIdentity.DraftBarRaiserDashboard}
    />
  );

  const fetchBarRaisersState = useBarRaisers(techDomain);

  const [dashboardOverview, setDashboardOverview] = useState<BarRaiserDashboardInfo>(
    BarRaiserDashboardInfo.create(0, 0, 0, 0),
  );

  // @ts-expect-error TS7006 - strict migration
  const onWorkflowListChange = (newWorkflowList) => {
    const { preauthorCount, publisherCount, nearSLACount, pastSLACount, totalCount } =
      getDashboardOverview(newWorkflowList);
    setDashboardOverview({
      preauthorCount,
      publisherCount,
      nearSLACount,
      pastSLACount,
      totalCount,
    });
  };

  return (
    <div>
      <Grid
        gridDefinition={[
          { colspan: { default: 12, xxs: 6 } },
          { colspan: { default: 12, xxs: 6 } },
        ]}
      >
        <BarRaiserDashboardOverview techDomain={techDomain} dashboardOverview={dashboardOverview} />
        <BarRaiserLeaderboard techDomain={techDomain} />
      </Grid>
      <br />
      <WorkflowTableContext.Provider value={{ fetchBarRaisersState }}>
        <ContentWorkflowTableV3
          stickyColumns={{ first: 2, last: 0 }}
          tableId={WorkflowTableIdentity.DraftBarRaiserDashboard}
          header={header}
          columnDefinitions={allContentTableColumns}
          tableSelectorOptions={contentSelectorOptions}
          tableDataProvider={tableDataProvider}
          onWorkflowListChange={onWorkflowListChange}
        />
      </WorkflowTableContext.Provider>
    </div>
  );
};
